// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject, NgZone, OnInit, ViewChild, AfterViewChecked
} from '@angular/core';
import {
  SohoMessageService,
  SohoModalDialogService, SohoSearchFieldComponent,
  SohoToastService
} from 'ids-enterprise-ng';
import { LMApplicationMenuService, LMApplicationMenuSubMenuService } from '@app/components';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMLoginService } from '@login/lm-login.service';
import { LMActionFormDialogService } from '@modal/lm-action-form-dialog.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMContextService } from '@services/lm-context.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMGlobalPersonalizationService, LMGlobalStateService } from '@app/states';
import { LMApplicationMenuAsOfDateDialogService } from '@components/applicationmenu/asofdate/lm-application-menu-asofdate-dialog.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMApplicationMenuSearchService } from '@components/applicationmenu/search/lm-application-menu-search.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMApplicationMenuUserContextDialogService } from '@app/components';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { Router } from '@angular/router';
import { LMApplicationMenuBaseDirective } from '@components/applicationmenu/lm-application-menu-base.directive';
import { LMBrowserUtilService, LMUniqueIdService } from '@app/utils';
import { LMThemeService } from '@banner/lm-theme.service';
import {
  LMRoamingUIProfileService,
  RoamingUIProfileResponse,
  RoamingUIProfileResult
} from '@services/lm-roamingUIProfile.service';
import { LMCreateReportDialogService, LMReportPersonalizationDialogService, LMReportsCatalogService } from '@report/index';
import * as urltemplate from 'url-template';
import { LMComponentInfoService, LMRouteComponentService } from '@app/services';
import { LMWebAppService } from '@services/lm-webapp.service';
import { LMKeyboardShortcutsDialogService } from "@modal/lm-keyboard-shortcuts-dialog.service";
@Component({
  selector: 'lm-application-menu-v1',
  templateUrl: 'lm-application-menu-v1.component.html',
  styleUrls: [ 'lm-application-menu-v1.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ LMRoamingUIProfileService ]
  })
export class LMApplicationMenuV1Component extends LMApplicationMenuBaseDirective implements OnInit, AfterViewChecked {
  @ViewChild('SearchField') searchField: SohoSearchFieldComponent;
  constructor(
    protected sohoModalDialogService: SohoModalDialogService,
    protected sohoToastService: SohoToastService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    protected lmContextService: LMContextService,
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmSpecService: LMSpecService,
    protected lmWebAppService: LMWebAppService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmLoginService: LMLoginService,
    protected lmContextUtilService: LMContextUtilService,
    protected lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmGlobalStateService: LMGlobalStateService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected sohoMessageService: SohoMessageService,
    protected lmApplicationMenuSearchService: LMApplicationMenuSearchService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmUserContextService: LMApplicationMenuUserContextDialogService,
    protected lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmBrowserUtilService: LMBrowserUtilService,
    @Inject(forwardRef(() => LMActionFormDialogService)) protected lmActionFormDialogService, // LMActionFormDialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected lmThemeService: LMThemeService,
    protected lmCreateReportDialogService: LMCreateReportDialogService,
    protected lmCommonReportsService: LMReportsCatalogService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected ngZone: NgZone,
    protected lmApplicationMenuSubMenuService: LMApplicationMenuSubMenuService,
    protected routeComponent: LMRouteComponentService,
    protected lmKeyboardShortcutsDialogService: LMKeyboardShortcutsDialogService
  ) {
    super(
      sohoModalDialogService,
      sohoToastService,
      lmAsOfDateService,
      lmContextService,
      lmApplicationMenuService,
      lmFormRequestService,
      lmFormatUtilService,
      lmSpecService,
      lmWebAppService,
      lmErrorUtilService,
      lmLoggerService,
      lmUrlUtilService,
      lmGlobalUtilService,
      lmLoginService,
      lmContextUtilService,
      lmReportPersonalizationDialogService,
      lmGlobalPersonalizationService,
      lmGlobalStateService,
      lmUniqueIdService,
      sohoMessageService,
      lmApplicationMenuSearchService,
      lmBusyIndicatorService,
      lmUserContextService,
      lmActionFormDialogService,
      changeDetectorRef,
      router,
      lmRoamingUIProfileService,
      lmThemeService,
      lmCreateReportDialogService,
      lmBrowserUtilService,
      lmCommonReportsService,
      lmComponentInfoService,
      ngZone,
      lmApplicationMenuSubMenuService,
      routeComponent,
      lmKeyboardShortcutsDialogService
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewChecked() {
    super.ngAfterViewChecked();

    // Kludge to disable autocomplete on application menu
    // Autocomplete callbacks are auto firing after IDS ModuleNav implemenation
    // https://jira.infor.com/browse/LMWEB-18716
    if (this.searchField) {
      const searchField = this.searchField['jQueryElement'];
      if (
        $(searchField)?.data('searchfield')?.autocompleteAPI?.settings?.displayResultsCallback &&
        $(searchField)?.data('searchfield')?.autocompleteAPI?.settings?.displayResultsCallback?.name !== 'noop'
      ) {
        const kludge = function noop() { return false; };
        $(searchField).data('searchfield').autocompleteAPI.settings.displayResultsCallback = kludge;
      }
    }
  }

  public onToggleActionMenu(e?: Event) {
    e?.stopImmediatePropagation();
    this.actionMenu.nativeElement.style.display = this.actionMenuIsOpen ? 'none' : 'block';
    this.actionMenuIsOpen = !this.actionMenuIsOpen;
  }

  public onSelectRole($event): void {
    ($event.currentTarget as HTMLElement).setAttribute('href', '#');
    this.selectRole($event);
  }

  public openLink(link: string) {
    if (link === this.notificationsUrl) {
      this.displayRedDot = false;
      // Convert timestamp from simplified ISO format (YYYY-MM-DDTHH:mm:ss.sssZ) to Landmark format (yyyyMMddHHmmssSS)
      const curTimeStamp = new Date().toISOString().slice(-24).replace(/\D/g, '').slice(0, 16);
      this.lmRoamingUIProfileService.setLastViewedNotification(curTimeStamp)
        .subscribe(
          (results: RoamingUIProfileResponse) => {
            if (results.status === RoamingUIProfileResult.COMPLETED) {
              this.lmLoggerService.log('RoamingUIProfile Updated');
            }
          });
    }
    const compiledTemplate = urltemplate.parse(link);
    link = compiledTemplate.expand({
      urlPdlOrDa: this.lmContextService.getUrlPdlOrDa(),
      webApp:     this.lmContextService.getCurrentWebAppSpec().webAppName
    });
    this.lmContextService.setClearNextPageState(true);
    this.lmGlobalUtilService.navigateByUrl(link);
  }
}
